import mapActions from './mapActions';

export default mapActions('my_operations', {
    fetchAll_url: data => `/api/work_operations/month_records/${data.employee_id}/${data.year}/${data.month}`,
    update_url: (id) => `/api/work_performance/${id}`,
    delete_url: (id) => `/api/work_performance/${id}`,
    create_url: () => '/api/work_performance'
});
